// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__miWpxX2aKQj+w","box":"box__uSEu1dEqqKXgI","info":"info__liiMVDMpZZnHZ"};